











import { Vue, Component, Prop } from 'vue-property-decorator';
import ResponsiveProductImage from '@/project/product/image/ResponsiveProductImage.vue';
import VideoRender from '@/project/video/ProductVideoRender.vue';
import { XS, SM, MD, MIN_LG } from '@/core/config/breakpointConfig';
import responsiveProductImageService from '@/project/product/image/responsiveProductImage.service';

@Component({
    components: { ResponsiveProductImage, VideoRender }
})
export default class ProductDetailsImageVideo extends Vue {
    @Prop({
        required: true,
        type: String
    }) url!: string;

    @Prop({
        type: String,
        validator: (value: string | undefined) => value === undefined || ['thumbnail', 'pdp', 'fullscreen'].includes(value)
    })
    private mediaMode!: 'thumbnail' | 'pdp' | 'fullscreen';

    @Prop({
        type: Boolean,
        default: false
    }) isVideo!: boolean;

    @Prop({
        type: String,
        default: ''
    }) imageName!: string;

    @Prop({
        type: Boolean,
        default: false
    }) isFirst!: boolean;

    private get productMediaSize(): string | object {
        switch (this.mediaMode) {
        case 'thumbnail':
            return responsiveProductImageService.ImageSizePlaceholderValues.W200;
        case 'pdp':
            return responsiveProductImageService.ImageSizePlaceholderValues.W700;
        case 'fullscreen':
            return {
                [XS]: responsiveProductImageService.ImageSizePlaceholderValues.W300,
                [SM]: responsiveProductImageService.ImageSizePlaceholderValues.W700,
                [MD]: responsiveProductImageService.ImageSizePlaceholderValues.W700,
                [MIN_LG]: responsiveProductImageService.ImageSizePlaceholderValues.W1400
            };
        }
        throw new Error('unknown image-mode: ' + this.mediaMode);
    }
}
